import { TextField } from "@material-ui/core";
import { compose } from "ramda";
import { memo } from "react";
import { UseFormMethods, useWatch } from "react-hook-form";

import { withError } from "../HOC";
import { CommonFormElProps } from "../types";

export type TextareaProps = {
  readonly limit: number | false;
  readonly register: UseFormMethods["register"];
  readonly placeholder?: string;
} & CommonFormElProps;

const Textarea = memo<TextareaProps>(
  ({
    defaultValue = "",
    disabled: isDisabled = false,
    hasError,
    id,
    label,
    limit,
    placeholder,
    register,
    required = false,
  }) => {
    const currentValue: null | string | undefined = useWatch({ name: id });

    return (
      <TextField
        autoComplete="off"
        disabled={isDisabled}
        defaultValue={defaultValue}
        error={hasError}
        helperText={`${currentValue?.length || 0} / ${limit}`}
        id={id}
        inputRef={register}
        InputProps={{
          multiline: true,
          name: id,
          notched: false,
          placeholder,
        }}
        InputLabelProps={{
          disabled: isDisabled,
          required: !isDisabled && required,
          shrink: true,
        }}
        label={label}
        variant="outlined"
      />
    );
  }
);

export const TextareaWithError = compose(withError)(Textarea);
